import { useSelector, useDispatch } from 'react-redux';
import { useCallback } from 'react';
import { login, logout } from '../store/authSlice';

export const useAuth = () => {
  const dispatch = useDispatch();
  const { user, token, isLoading, error, isAuthenticated } = useSelector(
    (state) => state.auth
  );

const handleLogin = useCallback(
  async (email, password) => {
    const result = await dispatch(login({ email, password }));
    
    // Правильная проверка:
    if (login.fulfilled.match(result)) {
      return { success: true, user: result.payload.user };

    } else if (login.rejected.match(result)) {
      // Ошибка логина
      return { 
        success: false, 
        error: result.payload || 'Ошибка авторизации' 
      };
    }
    
    return { success: false, error: 'Неизвестная ошибка' };
  },
  [dispatch]
);

  const handleLogout = useCallback(() => {
    dispatch(logout());
  }, [dispatch]);

  return {
    user,
    token,
    isLoading,
    error,
    isAuthenticated,
    login: handleLogin,
    logout: handleLogout,
  };
};